import { ResourceSection } from 'data/documents';
import {
  BaseTemplate,
  TemplateMeta,
  TemplateObjectType,
} from 'data/templates/api';
import { ProjectTemplateTask } from '../projects';
import { NormalizedDocumentTemplatePayload } from './api/transform';

export interface DocumentTemplateContentSection {
  content: string;
  documentSectionId: number;
  createdAt: number;
  createdBy?: number;
  versionNumber?: number;
  meta: {
    sectionType: 'PRIVATE' | 'PUBLIC';
    resourceSections?: ResourceSection<Partial<ProjectTemplateTask>>[];
  };
  versioningQueued?: boolean;
}
export interface DocumentTemplateContent {
  documentId: number;
  sections: DocumentTemplateContentSection[];
  title?: string;
}

export enum DocumentTemplateSourceType {
  Default = 'DEFAULT',
  SpaceTab = 'SPACE',
}

export interface DocumentTemplate extends BaseTemplate {
  objectType: TemplateObjectType.Document;
  templateContent: DocumentTemplateContent;
  draftContent?: DocumentTemplateContent;
  sourceType?: DocumentTemplateSourceType;
  templateMeta?: TemplateMeta;
}

export type DocumentTemplateStore = {
  [key: string]: {
    error: string | null;
    loading: boolean;
    isSaving?: boolean;
  } & NormalizedDocumentTemplatePayload;
};
